import { API_STATUS } from "../../../constants/apiStatus";

export const subscriptionsSliceInitialState = {
  subscriptions: [],
  userSubscription: null,
  subscriptionsData: null, // For paginated subscriptions data
  apiStatus: {
    getAllSubscriptions: API_STATUS.IDLE,
    getSubscriptionsWithFilters: API_STATUS.IDLE,
    getUserSubscription: API_STATUS.IDLE,
    createSubscription: API_STATUS.IDLE,
    updateSubscription: API_STATUS.IDLE,
    cancelSubscription: API_STATUS.IDLE,
  },
  error: null,
};
